module.exports = __webpack_public_path__ + "img/btn_stop@3x.a8ca4fdd.png";